// extracted by mini-css-extract-plugin
export var root = "style-modules--root--20Okg";